import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scleft",
  "use": "icon-scleft-usage",
  "viewBox": "0 0 258 144",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 258 144\" fill=\"none\" id=\"icon-scleft\">\n  <path d=\"M18.0835 13.7989C19.1821 5.88878 25.9453 0 33.9314 0H241.624C251.336 0 258.808 8.58171 257.472 18.2011L240 144H0L18.0835 13.7989Z\" fill=\"#EDF3FC\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol